import createCrudVuexModule from "@/store/crud";

export const domesticThirdParty = createCrudVuexModule({
  namespaced: true,
  path: "/library/domestic-third-party",
  moduleName: `domestic-third-party`,
});

export const workspaceDomesticThirdParty = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/domestic-third-party",
});

export const managementDomesticThirdParty = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/domestic-third-party",
});
